import FirebaseDoc from "@/model/FirebaseDoc"

export default class Deliverable extends FirebaseDoc{
  getStep(stepType) {
    return this.data[stepType]
  }
}